import { MutableRefObject } from 'react'
import { TChartDataRef } from '@/services/data/data.types.ts'
import { Dataset, ILineChartDataConfig, ILineChartDataPoint } from '@/shared/Charting/LineChart/lineChart.types.ts'
import { defaultColorOptions } from '@/shared/Inputs/ColorDropdown'
import { TParameterKey } from '@/pages/Parameters/parameters.types.ts'

/**
 * Перевести значения data-service в ожидаемый графиком Dataset
 * */
const dataRefAndDataConfigToDatasets = (
  dataRef: MutableRefObject<TChartDataRef>,
  dataConfig: ILineChartDataConfig
) => {
  let maxValue = Number.MIN_SAFE_INTEGER
  let minValue = Number.MAX_SAFE_INTEGER

  const colors = new Map<TParameterKey, string>()
  const valuesByParameterId = new Map<TParameterKey, ILineChartDataPoint[]>()
  const parameterIdsByDataParameterId = new Map<TParameterKey, TParameterKey[]>()

  for (let i = 0; i < dataConfig.parameters.length; ++i) {
    const parameter = dataConfig.parameters[i]
    colors.set(parameter.id, parameter.color || defaultColorOptions[i % defaultColorOptions.length].value)
    valuesByParameterId.set(parameter.id, [])

    const ids = parameterIdsByDataParameterId.get(parameter.dataParameterId) || []
    ids.push(parameter.id)
    parameterIdsByDataParameterId.set(parameter.dataParameterId, ids)
  }

  if (Array.isArray(dataRef.current[dataConfig.equipmentId])) {
    for (const dataPoint of dataRef.current[dataConfig.equipmentId]) {
      for (const value of dataPoint.values) {
        const matchingParameterIds = parameterIdsByDataParameterId.get(value.parameterId)
        if (!matchingParameterIds?.length) continue

        for (const parameterId of matchingParameterIds) {
          valuesByParameterId.get(parameterId)?.push({ ts: dataPoint.ts, value: value.value })
        }

        maxValue = Math.max(maxValue, value.value)
        minValue = Math.min(minValue, value.value)
      }
    }
  }

  const datasets: Dataset[] = []
  for (let i = 0; i < dataConfig.parameters.length; ++i) {
    const parameter = dataConfig.parameters[i]
    const color = colors.get(parameter.id)

    datasets.push({
      type: parameter.dataType === 'BOOLEAN' ? 'boolean' : 'numeric',
      data: valuesByParameterId.get(parameter.id) || [],
      color: color,
      label: parameter.name,
      id: parameter.id,
    })
  }

  return {
    minValue: minValue === Number.MAX_SAFE_INTEGER ? -1 : minValue,
    maxValue: maxValue === Number.MIN_SAFE_INTEGER ? 1 : maxValue,
    datasets,
  }
}

const dataRendererPluginUtils = { dataRefAndDataConfigToDatasets }
export default dataRendererPluginUtils
